import { frontendURL } from 'dashboard/helper/URLHelper.js';

const KanbanBoard = () => import('dashboard/modules/kanban/view/kanban.vue');

const kanbanRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_board',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: KanbanBoard,
    },
  ],
};

export default kanbanRoutes;
